var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('FileList',{attrs:{"assocID":_vm.assocID,"module":_vm.module}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }